<h2 mat-dialog-title *ngIf="editFarm.id === undefined"><i class="fas fa-plus me-2"></i>New Farm</h2>
<h2 mat-dialog-title *ngIf="editFarm.id !== undefined"><i class="fas fa-pen me-2"></i>Edit Farm for {{editFarm.name}}</h2>
<mat-dialog-content class="mat-typography">
  <!-- <nb-card-body style="overflow: visible;" [nbSpinner]="this.submitting"> -->
  <form (ngSubmit)="onSubmit()" id="farmForm" #farmForm="ngForm" class="new-block-form" [nbSpinner]="loading">

    <div class="row">
     <div class="col-md-5">
      <div class="row">
      <!-- Name -->
      <div class="col-12">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <mat-label>Name</mat-label>
            <input type="text" matInput id="name" name="name" [(ngModel)]="editFarm.name" placeholder='Name'
              [value]="editFarm?.name" required #name="ngModel">
          </mat-form-field>
          <div class="row" [hidden]="name.valid || name.pristine" class="alert alert-danger">Name is required</div>
        </div>
      </div>
      <!-- Address -->
      <div class="col-12">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <mat-label>Street Address</mat-label>
            <input type="text" matInput id="streetAddress" name="streetAddress"
              [(ngModel)]="editFarm.streetAddress" placeholder='Street Address' [value]="editFarm.streetAddress"
              #streetAddress="ngModel">
          </mat-form-field>
          <div class="row" [hidden]="streetAddress.valid || streetAddress.pristine" class="alert alert-danger">Street
            Address is
            required
          </div>
        </div>
      </div>

      <!-- City -->
      <div class="col-12">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <mat-label>City</mat-label>
            <input type="text" matInput id="city" name="city" [(ngModel)]="editFarm.city" placeholder='City'
              [value]="editFarm.city" #city="ngModel">
          </mat-form-field>
          <div class="row" [hidden]="city.valid || city.pristine" class="alert alert-danger">City is required</div>
        </div>
      </div>
 
      <!-- State -->
      <div class="col-12"> 
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <mat-label>State</mat-label>
            <input type="text" matInput id="state" name="state" [(ngModel)]="editFarm.state"
              placeholder='State' [value]="editFarm.state" #state="ngModel">
          </mat-form-field>
          <div class="row" [hidden]="state.valid || state.pristine" class="alert alert-danger">State is required</div>
        </div>
      </div>

      <!-- Zip -->
      <div class="col-12">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <mat-label>Zip Code</mat-label>
            <input type="text" matInput id="zipCode" name="zipCode" [(ngModel)]="editFarm.zipCode"
              placeholder='Zip Code' [value]="editFarm.zipCode" #zipCode="ngModel">
          </mat-form-field>
          <div class="row" [hidden]="zipCode.valid || zipCode.pristine" class="alert alert-danger">Zip Code is required
          </div>
        </div>
      </div>

      <!-- Email -->
      <div class="col-12">
        <div class="form-group mb-0">
          <mat-form-field class="d-block notification-email-field" appearance="fill">
            <mat-label>Email</mat-label>
            <mat-chip-grid #emailChipGrid aria-label="Email addresses">
              <mat-chip-row *ngFor="let email of emailList" (removed)="removeEmail(email)">
                {{ email }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
              <input placeholder="Add email address..." autocomplete="off" [formControl]="emailControl" [matChipInputFor]="emailChipGrid"
                [matChipInputSeparatorKeyCodes]="notificationEmailSeparatorKeyCodes" [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addEmail($event)" (keydown.backspace)="removeLastEmailOnBackspace($event)">
            </mat-chip-grid>
          </mat-form-field>
          <div class="alert alert-danger mt-2 mb-0" *ngIf="emailAddAttempted">
            Please enter a valid email address
          </div>
        </div>
      </div>



      <!--Tank Size-->
      <div class="col-md-12" *ngIf="showFields">
        <div class="form-group d-flex justify-content-between">
          <mat-form-field class="d-block">
            <mat-label>Default Tank Size</mat-label>
            <input type="number" matInput id="defaultTankSize" name="default TankSize"
              [(ngModel)]="editFarm.defaultTankSize" placeholder='Default Tank Size' [value]="editFarm.defaultTankSize"
              #defaultTankSize="ngModel">
          </mat-form-field>

          <mat-form-field  class="ps-3 w-50">
            <mat-label>Unit</mat-label>
            <mat-select [(ngModel)]="editFarm.defaultTankSizeUnit"  [ngModelOptions]="{standalone: true}">
              <mat-option *ngFor="let unit of units" [value]="unit">
                {{ unit }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="row" [hidden]="defaultTankSize.valid || defaultTankSize.pristine" class="alert alert-danger">
            Default TankSize is invalid
          </div>
        </div>
      </div>

      
      <!--Spray Volume-->
      <div class="col-md-12" *ngIf="showFields">
        <div class="form-group d-flex justify-content-between">
          <mat-form-field class="d-block">
            <mat-label>Default Volume</mat-label>
            <input type="number" matInput id="defaultVolume" name="defaultVolume"
              [(ngModel)]="editFarm.defaultVolume" placeholder='Default Volume' [value]="editFarm.defaultVolume"
              #defaultVolume="ngModel">
          </mat-form-field>
 
          <mat-form-field class="w-50 ps-3">
            <mat-label>Unit</mat-label>
            <mat-select
              [(ngModel)]="editFarm.defaultVolumeUnit"
              [ngModelOptions]="{standalone: true}"
            >
              <mat-option *ngFor="let unit of units" [value]="unit">
                {{ unit }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="row" [hidden]="defaultVolume.valid || defaultVolume.pristine" class="alert alert-danger">
            Default Volume is invalid
          </div>
        </div>
      </div>

      <!--Integration Id-->
      <div class="col-12">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <mat-label>Integration Id</mat-label>
            <input type="integrationId" matInput id="integrationId" name="integrationId"
              [(ngModel)]="editFarm.integrationId" placeholder='Integration Id' [value]="editFarm.integrationId"
              #integrationId="ngModel">
          </mat-form-field>
          <div class="row" [hidden]="integrationId.valid || integrationId.pristine" class="alert alert-danger">
            Integration
            Id is invalid
          </div>
        </div>
      </div>

      <!--Customer Id-->
      <div class="col-12">
        <div class="form-group mb-0">
          <mat-form-field class="d-block">
            <mat-label>Customer Name</mat-label>
            <input type="text"
            placeholder="Pick one"
            aria-label="Number"
            autocomplete="off"
            matInput
            [formControl]="myControl"
            [matAutocomplete]="auto">
            <mat-autocomplete  #auto = "matAutocomplete" [displayWith]="displayFn"
            (optionSelected)="onCustomerSelected($event.option.value)"
         
            >
              <mat-option *ngFor = "let Customer of filteredCustomers$ | async " [value] = "Customer">
                 {{Customer.name}} 
              </mat-option>
           </mat-autocomplete>
          </mat-form-field>
          
        </div>
      </div>

      <!-- Active Checkbox -->
      <!-- <div class="col-12 mt-3" *ngIf="editFarm.id === undefined">
        <div class="form-group mb-0">
          <mat-checkbox placeholder="Active" name="active" id="active" [(ngModel)]="editFarm.isActive"
            [(value)]="editFarm.isActive" #active="ngModel" color="primary">Active</mat-checkbox>
        </div>
      </div> -->

      <!-- Notifications Checkbox -->
      <div class="col-12 mt-3">
        <div class="form-group mb-0">
          <mat-checkbox placeholder="Send Notifications" name="notifications" id="notifications" [(ngModel)]="editFarm.notificationsEnabled"
            [(value)]="editFarm.notificationsEnabled" #notifications="ngModel" color="primary"
            (change)="onNotificationsEnabledChange($event.checked)">Send Notifications</mat-checkbox>
        </div>
      </div>

      <!-- Email Notifications -->
      <div class="col-md-12 mt-3" #notificationEmailSection *ngIf="editFarm.notificationsEnabled">
        <div class="form-group mb-0">
          <mat-form-field class="d-block notification-email-field" appearance="fill">
            <mat-label>Email Address</mat-label>
            <mat-chip-grid #notificationEmailChipGrid aria-label="Notification email addresses">
              <mat-chip-row *ngFor="let notificationEmail of notificationEmailList"
                (removed)="removeNotificationEmail(notificationEmail)">
                {{ notificationEmail }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip-row>
              <input #notificationEmailInputRef placeholder="Add email address..." autocomplete="off"
                [formControl]="notificationEmailControl"
                [matChipInputFor]="notificationEmailChipGrid"
                [matChipInputSeparatorKeyCodes]="notificationEmailSeparatorKeyCodes"
                [matChipInputAddOnBlur]="true"
                (matChipInputTokenEnd)="addNotificationEmail($event)"
                (keydown.backspace)="removeLastNotificationEmailOnBackspace($event)">
            </mat-chip-grid>
          </mat-form-field>
          <div class="alert alert-danger mt-2 mb-0" *ngIf="notificationEmailAddAttempted">
            Please enter a valid email address
          </div>
        </div>
      </div>
      </div>
     </div>
     <div class="col-md-7">
      <!-- GPS Location (optional) -->
      <div>
        <div class="d-flex align-items-center justify-content-between mb-2">
          <strong>GPS Location <span class="text-muted fw-normal">(optional)</span></strong>
          <div>
            <button type="button" class="btn btn-sm btn-outline-secondary me-2" (click)="locateFromAddress()"
              [disabled]="locationSearching">
              <i class="fas fa-search-location me-1"></i>Find from address
            </button>
            <button type="button" class="btn btn-sm btn-outline-secondary" (click)="clearLocation()"
              [disabled]="!hasLocation()">
              <i class="fas fa-times me-1"></i>Clear
            </button>
          </div>
        </div>
        <div class="alert alert-warning py-1 px-2" *ngIf="locationSearchFailed">
          Couldn't find a location from the address. Click the map to set it manually.
        </div>
        <div class="row">
          <div class="col-6">
            <mat-form-field class="d-block">
              <mat-label>Latitude</mat-label>
              <input type="number" matInput id="latitude" name="latitude" min="-90" max="90" step="any"
                [(ngModel)]="editFarm.latitude" (ngModelChange)="onCoordinateInput()">
            </mat-form-field>
          </div>
          <div class="col-6">
            <mat-form-field class="d-block">
              <mat-label>Longitude</mat-label>
              <input type="number" matInput id="longitude" name="longitude" min="-180" max="180" step="any"
                [(ngModel)]="editFarm.longitude" (ngModelChange)="onCoordinateInput()">
            </mat-form-field>
          </div>
        </div>
        <div #locationMap class="location-map"></div>
        <small class="text-muted">Click the map to place the farm, then drag the pin to adjust.</small>
      </div>

     </div>
    </div>
  </form>
</mat-dialog-content>
<mat-dialog-actions class="pb-0">
  <div class="custom-dialog-actions">
    <div class="btn-group">
      <button *ngIf="!submitting" type="submit" [disabled]="!farmForm.valid" form="farmForm"
       class="custom-button save-button"> <span class="fa-icon-wrapper"><i class="fas fa-save"></i></span>Save</button>
      <mat-spinner *ngIf="submitting" [diameter]="20"></mat-spinner>
      <button class="d-flex align-items-center justify-content-start border-0 custom-button cancel-button" (click)="closeDialog()">
        <span class="fa-icon-wrapper"><i class="fas fa-times"></i></span>Cancel
      </button>
    </div>
  </div>
</mat-dialog-actions>
<!-- <nb-card-footer class="row" style="margin-top: 10px;">
    <div class="col-md-auto d-flex align-items-center">
      <button *ngIf="!submitting" type="button" form="farmForm" [disabled]="!this.editFarm.id" mat-raised-button
        color="warn" (click)="setFarmInactive();">Delete</button>
    </div>
    
  </nb-card-footer> -->
<!-- </nb-card> -->